/* =============================================================================
   KNN Stamped Rewards — timeout fallback

   Stamped fills its rewards containers with a spinner immediately and only
   replaces it once the loyalty API answers. When that call fails the spinner is
   never replaced, so the page spins forever with no way out — which is exactly
   what vitalyrahealth.com/pages/rewards did while Stamped had the loyalty
   feature flag on but no program configured behind it (the launcher endpoint
   returned HTTP 500 "getRuleCorrelationId").

   This swaps that dead spinner for the editable message in the section after a
   configurable wait. Config and copy both come from the Liquid, so nothing here
   needs changing to adjust either.
   ============================================================================= */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.knn-stamped-rewards[data-knn-strw-timeout]';
  var WIDGET_SELECTOR = '.knn-stamped-rewards__widget';
  var FALLBACK_SELECTOR = '.knn-stamped-rewards__fallback';
  var ARMED_ATTR = 'data-knn-strw-armed';

  /* Stamped's own success signal. Inside widget.min.js the loyalty request's
     success handler calls its event helper with this name, and that helper
     dispatches a CustomEvent on `document` — so this fires if and only if the
     API actually answered. Listening for it is far steadier than watching for
     Stamped's markup to appear, because it does not depend on any of the app's
     class names, which are not ours and can change under us.

     Bound at file scope rather than per section: the event fires once for the
     whole page, and it can fire before a section has been armed. */
  var answered = false;

  document.addEventListener('stamped:rewards:init', function () {
    answered = true;
  });

  /* A spinner carries no text; every real widget does ("How it Works",
     "Sign Up", a points total). So non-empty text is the one signal that says
     Stamped got as far as rendering, and it needs no knowledge of its markup.

     This is the backstop for the event above, covering the case where Stamped
     renders through a path that does not dispatch it. */
  function hasRendered(section) {
    var widgets = section.querySelectorAll(WIDGET_SELECTOR);

    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].textContent.trim() !== '') return true;
    }

    return false;
  }

  function reveal(section) {
    /* Re-checked here, not just when the timer was set: the whole point is to
       judge the situation at the deadline, not before it. */
    if (answered || hasRendered(section)) return;

    section.setAttribute('data-knn-strw-state', 'failed');

    var fallback = section.querySelector(FALLBACK_SELECTOR);
    if (fallback) fallback.removeAttribute('hidden');
  }

  function arm(section) {
    if (section.getAttribute(ARMED_ATTR) === 'true') return;

    var timeout = parseInt(section.getAttribute('data-knn-strw-timeout'), 10);
    if (!timeout) return;

    section.setAttribute(ARMED_ATTR, 'true');

    setTimeout(function () {
      reveal(section);
    }, timeout);
  }

  function armAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) arm(sections[i]);
  }

  /* The theme editor replaces the whole section node on every setting change.
     The replacement is fresh DOM, so it carries no armed flag and re-arms on
     its own; `answered` survives, so a section that already loaded fine does
     not flash the fallback on the next edit. */
  document.addEventListener('shopify:section:load', armAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armAll);
  } else {
    armAll();
  }
})();
